import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=6a7ed80a&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=6a7ed80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ed80a",
  null
  
)

export default component.exports